import { TIconName } from '../Icon';
import { TLoaderView } from './models';

export const LOADER_ICON_NAME: { [x in TLoaderView]: TIconName } = {
  dark: 'circleLoaderDark',
  white: 'circleLoaderWhite',
};
